import React, { useState, useRef } from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { Reviews } from './Reviews';
import { WebinarDetails } from './WebinarDetails';
import { FAQ } from './FAQ';
import { Benefits } from './Benefits';
import { CallToAction } from './CallToAction';
import { MoreTestimonials } from './MoreTestimonials';
import { Footer } from './Footer';
import { WebinarModal } from './WebinarModal';
import { FacebookPixel } from './FacebookPixel';
import { StickyButton } from './StickyButton';
export const Advertorial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const stickyButtonTargetRef = useRef<HTMLHeadingElement>(null);
  const openModal = () => {
    window.location.href = 'https://stresslessdogs.nl/mcc-meta-adv2';
  };
  const closeModal = () => setIsModalOpen(false);
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800 pb-32" data-id="element-6">
      <FacebookPixel data-id="element-7" />
      <WebinarModal isOpen={isModalOpen} onClose={closeModal} data-id="element-8" />
      <Header openModal={openModal} data-id="element-9" />
      <Problem openModal={openModal} data-id="element-10" />
      <Solution openModal={openModal} stickyButtonTargetRef={stickyButtonTargetRef} data-id="element-11" />
      <Testimonials openModal={openModal} data-id="element-12" />
      <WebinarDetails openModal={openModal} data-id="element-13" />
      <Reviews data-id="element-14" />
      <FAQ openModal={openModal} data-id="element-15" />
      <Benefits openModal={openModal} data-id="element-16" />
      <CallToAction openModal={openModal} data-id="element-17" />
      <MoreTestimonials data-id="element-18" />
      <Footer openModal={openModal} data-id="element-19" />
      <StickyButton targetRef={stickyButtonTargetRef} onClick={openModal} data-id="element-20" />
    </div>;
};